<template>
  <div class="listatickets">
    <div class="ticket col-12" v-for="(dato, index) in listatickets" :key="index">
      <div class="fecha text-left">
        <p class="mb-0 datofecha">Fecha: {{ dato.fechaVentas | shortDate }}</p>
      </div>
      <div class="listarticulos">
        <div class="articulo pb-3" v-for="(articulo, posicion) in listatickets[index].desgloses" :key="posicion">
          <div class="datosart mt-3 d-flex">
            <img v-bind:src="getFoto(articulo.articId)" width="90" class="fotoart img-thumbnail" />
            <div class="ml-3 datosarticu">
              <h6 class="mb-0 mt-1">{{ articulo.articModelo }}</h6>
              <p class="mt-0 mb-0 codigo">{{ articulo.desgloseEAN }}</p>
              <p class="mt-2 ml-1 mb-0 cantdes">{{ articulo.desgloseUnid }} unidad</p>
              <p class="mt-2 ml-1 mb-0 cantdes">
                <span v-if="articulo.lineaDto != null">Descuento {{ articulo.lineaDto }} €</span> <span class="precio"> {{ articulo.desglosePVenta.toString().replace('.', ',') }} €</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="datoscompra">
        <div class="datosc">
          <p>
            Subtotal <span>{{ dato.totalart.replace(/\./, ',') }}€</span>
          </p>
          <div class="datosiva">
            <p>
              Base imponible <br /><span>{{ dato.base.toString().replace('.', ',') }}€</span>
            </p>
            <p>I.V.A <br /><span>21%</span></p>
            <p class="pre">
              Precio <br /><span>{{ dato.iva }}€</span>
            </p>
          </div>
          <hr />
          <p>
            Total impuestos incluidos<span>{{ dato.total }}€</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tickets: {
      type: String,
      required: true,
    },
    fotos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      ticketsJson: {},
      listatickets: [],
      descuento: 0,
      iva: 0,
      total: 0,
    };
  },
  watch: {
    tickets: function(newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
    },
  },
  methods: {
    generarCalculos() {
      for (let i = 0; i < this.listatickets.length; i++) {
        this.descuento = 0;
        this.iva = 0;
        this.total = 0;

        for (let x = 0; x < this.listatickets[i].desgloses.length; x++) {
          if (this.listatickets[i].desgloses[x].lineaDto !== null && this.listatickets[i].desgloses[x].lineaDto !== '') {
            this.descuento += parseFloat(this.listatickets[i].desgloses[x].lineaDto);
          }
          if (this.listatickets[i].desgloses[x].desglosePVenta !== null && this.listatickets[i].desgloses[x].desglosePVenta !== '') {
            this.total += parseFloat(this.listatickets[i].desgloses[x].desglosePVenta);
          }
        }

        this.listatickets[i].descuento = parseFloat(this.descuento).toFixed(2);
        this.listatickets[i].totalart = parseFloat(this.total).toFixed(2);
        this.listatickets[i].base = parseFloat(this.listatickets[i].totalart * 1.21).toFixed(2);
        this.listatickets[i].iva = parseFloat((this.listatickets[i].base * 21) / 100).toFixed(2);
        this.listatickets[i].total = (parseFloat(this.listatickets[i].totalart) - parseFloat(this.listatickets[i].descuento)).toFixed(2).replace(/\./g, ',');
        this.listatickets[i].descuento = this.listatickets[i].descuento.replace(/\./, ',');
        this.listatickets[i].iva = this.listatickets[i].iva.replace(/\./, ',');
      }
    },
    getFoto(idArtic) {
      if (this.fotos.find((foto) => foto.articulo === idArtic)) {
        return this.fotos.find((foto) => foto.articulo === idArtic).url;
      } else {
        return require('@/assets/images/noimg.jpg');
      }
    },
  },
  created() {
    this.ticketsJson = JSON.parse(this.tickets);
    this.listatickets = this.ticketsJson.lineas;
    this.generarCalculos();
  },
};
</script>
<style scoped>
.contenedor {
  background-color: white;
  border-radius: 0.5em;
  margin: 0 auto;
  width: 550px;
}
.ticket {
  border: 1px solid #c8c8cc;
  padding: 0 !important;
}

.articulo {
  text-align: left !important;
  border-top: 1px solid #c8c8cc;
}

.articulo:nth-of-type(1) {
  border-top: 0;
}

.articulo h6 {
  font-weight: bold;
  margin-top: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 90%;
  font-size: 10.5pt;
}

.articulo:nth-of-type(1) h6 {
  margin-top: 0px;
}

.datofecha {
  color: #707070;
  font-size: 11pt;
  margin-top: 10px;
}

.listarticulos {
  margin-left: 4%;
  margin-right: 4%;
}

.listatickets {
  width: 95%;
  height: 500px;
  overflow: auto;
  margin: 0 auto;
}

.datosarticu p {
  font-size: 10pt;
}

.datoscompra {
  border-top: 2px solid #c8c8cc;
  display: flex;
  justify-content: space-between;
}

.datoscompra p {
  margin-bottom: 4px;
  text-align: right;
}

.cerrar button {
  color: #27629d;
  font-size: 13pt;
  padding-right: 1.5%;
}

.codigo {
  color: #b1b1b5;
}

.fotoart {
  padding: 0 !important;
}

.fecha {
  margin-left: 17px;
}

.datosc {
  margin-right: 4%;
  margin-top: 3%;
  padding-bottom: 10px;
  width: 100%;
  margin-left: 5%;
}

.datosiva {
  display: flex;
  justify-content: space-between;
}

hr {
  margin-top: 10px;
  margin-bottom: 10px;
  border-top: 1px solid #27629d;
}

.datosc p:nth-of-type(1) {
  color: #2562a4;
}

.datosc div p {
  margin-top: 8px;
  color: #707070 !important;
  text-align: center;
}

.datosc div span {
  margin-left: 0 !important;
}

.datosc p:last-child {
  color: #2562a4;
}

.datosc span {
  font-size: 12pt;
  margin-left: 10px;
}

.precio {
  float: right;
  color: #27629d;
  font-size: 15pt;
  margin-top: -8px;
}

.cantdes {
  color: #707070;
}

.cerrar span {
  color: #27629d;
  font-size: 12pt;
  font-weight: bold;
  padding-left: 2%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

@media (max-width: 1400px) {
  .datosc p:nth-of-type(3) {
    padding-bottom: 0px;
  }

  .cerrar span {
    padding-left: 0px;
  }

  .cerrar button {
    padding-right: 0px;
  }
}

@media (max-width: 900px) {
  .contenedor {
    margin-left: 165px;
  }
}

@media (max-width: 800px) {
  .contenedor {
    margin-left: 100px;
  }
}

@media (max-width: 700px) {
  .contenedor {
    margin-left: 50px;
  }
}

@media (max-width: 641px) {
  .contenedor {
    width: 500px;
  }
}

@media (max-width: 600px) {
  .contenedor {
    width: 450px;
  }
}

@media (max-width: 550px) {
  .contenedor {
    margin-left: 30px;
  }
}

@media (max-width: 490px) {
  .contenedor {
    width: 390px;
    margin-left: 1.5vh;
  }
}

@media (max-width: 400px) and (min-height: 530px) {
  .contenedor {
    width: 340px;
  }

  .ticket {
    width: 98%;
  }
}

@media (max-width: 350px) and (max-height: 570px) {
  .contenedor {
    width: 305px;
  }
}
</style>
